import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IEmailField {
	changeEmail: (value: string) => void;
}

const EmailField: React.FC<IEmailField> = ({ changeEmail }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterEmail') },
			{
				type: 'email',
				message: t('invalidEmail'),
			},
		],
		[t],
	);

	return (
		<FormInput
			testId="EmailField"
			name="email"
			label="emailLabel"
			onChange={changeEmail}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(EmailField);
